import { ApplicationState } from 'ducks/application-state';

export const selectComments = (state: ApplicationState) => state.comments.list;
export const selectCommentsPagination = (state: ApplicationState) => state.comments.pagination;
export const selectCommentsSort = (state: ApplicationState) => state.comments.sort;
export const selectCommentsLoading = (state: ApplicationState) => state.comments.loading;
